import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CheckoutLineItem from './CheckoutLineItem';
import DiscountForm from '../../CartSummary/DiscountForm';
import CartOrderSummary from '../../CartSummary/CartOrderSummary';
import Accordion from '../../Accordion';
import AccordionItem from '../../Accordion/AccordionItem';
import Loading from '../../Loading';

import './CheckoutOrderSummary.scss';
import { trackAccordion } from '../../../../analytics/category/checkout';

const handleAccordionTracking = (action) => {
  trackAccordion(action, 'Checkout Order Summary');
};

const CheckoutOrderSummaryContent = props => {
  return (
    <section className="checkout-order-summary">
      {!props.tabletDown &&
        <React.Fragment>
          <div className="checkout-order-summary-title">
            {props.title}
          </div>
          <hr />
        </React.Fragment>
      }
      {props.isCartLoading
        ? <Loading dark relative small />
        : props.items.map(item => (
          <CheckoutLineItem
            key={`item-${item.id}`}
            item={item}
            editItemCta={props.editItemCta}
            modalTitle={props.modalTitle}
            modalContent={props.modalContent}
            modalCloseText={props.modalCloseText}
            isCheckout
            hasModal
          />
        ))
      }
      <DiscountForm
        values={props.values}
        cta={props.discountFormCta}
        placeholder={props.discountFormPlaceholder}
        isTwoColumnLayout
      />
      <hr />
      {props.summary.totals &&
        <CartOrderSummary
          itemCount={props.summary.items.length}
          label={props.labels}
          value={props.values}
          summary={props.summary}
          removeCta={props.discountFormRemoveCta}
          showShippingPrice
          showSalesTax
        />
      }
    </section>
  );
};

const CheckoutOrderSummary = props => {
  if (props.tabletDown) {
    return (
      <Accordion>
        <AccordionItem
          trackToggleEvent={handleAccordionTracking}
          label={[props.title, get(props, 'values.discountedTotal.formatted', '')]}
          isExpanded={props.isExpanded}>
          <CheckoutOrderSummaryContent {...props} />
        </AccordionItem>
      </Accordion>
    );
  }
  return <CheckoutOrderSummaryContent {...props} />;
};

const propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array,
  values: PropTypes.object,
  discountFormCta: PropTypes.string.isRequired,
  discountFormRemoveCta: PropTypes.string,
  discountFormPlaceholder: PropTypes.string,
  editItemCta: PropTypes.string,
  summary: PropTypes.object,
  labels: PropTypes.object,
  isCartEmpty: PropTypes.bool,
  tabletDown: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isCartLoading: PropTypes.bool,
  modalTitle: PropTypes.string.isRequired,
  modalContent: PropTypes.array,
  modalCloseText: PropTypes.string,
  history: PropTypes.object,
};

CheckoutOrderSummaryContent.propTypes = propTypes;
CheckoutOrderSummary.propTypes = propTypes;

export default CheckoutOrderSummary;



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutOrderSummary/CheckoutOrderSummary.js